module.exports = __webpack_public_path__ + "reportedPhoto.3fb8b22.png";